import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "./index";

export const authAPI = createApi({
    reducerPath: "authApi",
    baseQuery: baseQuery,
    tagTypes: ["Auth"],
    endpoints: (builder) => ({
        login: builder.mutation({
            query: (payload) => ({
                url: "/auth/login",
                method: "POST",
                body: payload,
            }),
        }),
        forgotPassword: builder.mutation({
            query: (payload) => ({
                url: "/auth/forgotPassword",
                method: "POST",
                body: payload,
            }),
        }),
        resetPassword: builder.mutation({
            query: (payload) => ({
                url: "/auth/resetPassword",
                method: "POST",
                body: payload,
            }),
        }),
        changePassword: builder.mutation({
            query: (payload) => ({
                url: "/auth/changePassword",
                method: "POST",
                body: payload,
            }),
        }),
        verifyOtp: builder.mutation({
            query: (body) => ({
                url: "/auth/verify-otp",
                method: "POST",
                body,
            }),
        }),
        resetNewPassword: builder.mutation({
            query: (payload) => ({
                url: "/auth/reset-subadmin-token",
                method: "POST",
                body: payload,
            }),
        }),
    }),
});

export const {
    useLoginMutation,
    useForgotPasswordMutation,
    useResetPasswordMutation,
    useVerifyOtpMutation,
    useChangePasswordMutation,
    useResetNewPasswordMutation
} = authAPI;
